import axios from "axios";
import { CONFIG } from "../config";


const API_BASE = `${CONFIG.API_URL}/api`;

function getCookie(name) {
    let cookieValue = null;
    if (document.cookie && document.cookie !== "") {
      const cookies = document.cookie.split(";");
      for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].trim();
        if (cookie.startsWith(name + "=")) {
          cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
          break;
        }
      }
    }
    return cookieValue;
  }
  
const api = axios.create({
  baseURL: API_BASE,
  /* withCredentials: true, */
  headers: {
    "X-CSRFToken": getCookie("csrftoken"),
  },
});

api.interceptors.request.use(
  (config) => {
    const token = getCookie('csrftoken');
    if (token) {
      config.headers['X-CSRFToken'] = token;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// ----------------------------------
// Users & Applications
// ----------------------------------
export async function sendApplication (data) {
    const formData = new FormData();
    formData.append("first_name",data.firstName);
    formData.append("last_name",data.lastName);
    formData.append("major",data.major);
    formData.append("contact_phone",data.contactPhone);
    formData.append("contact_email",data.contactEmail);
    formData.append("job_title",data.jobTitle);
    formData.append("yoe",data.yoe);
    formData.append("goal_prof",data.goalProf);
    formData.append("goal_target",data.goalTarget);
    formData.append("expectations_env",data.expectationsEnv);
    formData.append("expectations_hr",data.expectationsHr);
    formData.append("highest_edu",data.highestEdu);
    formData.append("current_act",data.currentAct);
    formData.append("strenght_weakness",data.strenghtWeakness);
    formData.append("residency",data.residency);
    formData.append("dob",data.dob);

    if(data.resumeFile instanceof File) {
        formData.append("resume_file", data.resumeFile);
    }
    const res = await api.post("/application/", formData);
    return res.data
}

// ----------------------------------
// Users & Accounts
// ----------------------------------

export const deleteUserAccount = (i) => api.delete(`/user/delete-request/`);

// --------------------------------------------------------------------------------